import {
  Directive,
  ElementRef,
  Renderer2,
  HostListener,
  Optional,
  Self
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[rutFormater]'
})
export class RutFormaterDirective {
  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
    @Optional() @Self() private readonly ngControl: NgControl
  ) {}

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = this.el.nativeElement;
    const original = input.value;

    const cleanedRut = this.clean(original);
    const formattedRut = this.format(cleanedRut);

    // Solo actualiza el input visualmente
    if (original !== formattedRut) {
      this.renderer.setProperty(input, 'value', formattedRut);

      // Mantiene el cursor al final (opcional)
      input.setSelectionRange(formattedRut.length, formattedRut.length);
    }

    // No actualizamos el FormControl aquí
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    const cleaned = this.clean(value);
    if (cleaned.length < 2) {
      return;
    }

    const formatted = this.format(cleaned);

    // Aquí sí actualizamos el FormControl con el valor final
    this.ngControl?.control?.setValue(formatted);
  }

  private clean(rut: string): string {
    return typeof rut === 'string'
      ? rut.replace(/[^0-9kK]+/g, '').toUpperCase()
      : '';
  }

  private format(rut: string): string {
    if (!rut || rut.length < 2) return rut;

    const body = rut.slice(0, -1);
    const dv = rut.slice(-1);
    let formatted = '';
    let i = 0;

    for (let j = body.length - 1; j >= 0; j--) {
      formatted = body[j] + formatted;
      i++;
      if (i % 3 === 0 && j !== 0) {
        formatted = '.' + formatted;
      }
    }

    return formatted + '-' + dv;
  }
}
